import moment from 'moment';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CodeName } from "@/store/common";

//Page State
export type OutputDataWarehousingSaveState = {
  //
  ymdFrom: Date,
  ymdTo: Date,
  //倉庫
  center: CodeName | null,
  //メーカー
  maker: CodeName | null,

};

export const initialState: OutputDataWarehousingSaveState = {
  //
  ymdFrom: null,
  ymdTo: null,
  //倉庫
  center: null,
  //メーカー
  maker: null,

};

//Page Slice
const createSliceContent = (name: string) => createSlice({
  name: name,
  initialState,
  reducers: {
    //componentDidMount
    initOnDidMount(state: OutputDataWarehousingSaveState) {
      //追加属性等はlocalstorageから復元したときにundefinedになっている場合があるためチェックする
      if (!state.ymdFrom && !state.ymdTo) {
        state.ymdFrom = moment(new Date()).startOf('days').toDate();
        state.ymdTo = moment(new Date()).startOf('days').add(14, 'days').toDate();
      }
      if (typeof state.ymdFrom === 'string') {
        state.ymdFrom = moment(state.ymdFrom).toDate();
      }
      if (typeof state.ymdTo === 'string') {
        state.ymdTo = moment(state.ymdTo).toDate();
      }

      if (!state.center) {
        state.center = initialState.center;
      }
      if (!state.maker) {
        state.maker = initialState.maker;
      }
    },
    setYmdFrom(state: OutputDataWarehousingSaveState, action: PayloadAction<Date>) {
      state.ymdFrom = action.payload;
      if (state.ymdTo && state.ymdFrom) {
        const dateFrom = moment(state.ymdFrom);
        const dateTo = moment(state.ymdTo);
        const diff = dateFrom.diff(dateTo, 'days');
        if (diff > 0 || diff < -14) {
          state.ymdTo = dateFrom.clone().add(14, 'days').toDate();
        }
      }
    },
    setYmdTo(state: OutputDataWarehousingSaveState, action: PayloadAction<Date>) {
      state.ymdTo = action.payload;
      if (state.ymdTo && state.ymdFrom) {
        const dateFrom = moment(state.ymdFrom);
        const dateTo = moment(state.ymdTo);
        const diff = dateFrom.diff(dateTo, 'days');
        if (diff > 0 || diff < -14) {
          state.ymdFrom = dateTo.clone().add(-14, 'days').toDate();
        }
      }
    },
    // Option Center
    setCenter(state: OutputDataWarehousingSaveState, action: PayloadAction<CodeName>) {
      state.center = action.payload;
    },
    setCenterList(state: OutputDataWarehousingSaveState, action: PayloadAction<CodeName[]>) {
      const centerList = action.payload;
      let center = state.center && state.center.code ? centerList.find((center) => center.code == state.center.code) : null;
      if (!center) {
        center = centerList[0];
      }
      state.center = center;
    },
    setMaker(state: OutputDataWarehousingSaveState, action: PayloadAction<CodeName>) {
      state.maker = action.payload;
    },
    clearOption(state: OutputDataWarehousingSaveState, action: PayloadAction<{
      centerList: CodeName[],
      makerList: CodeName[],
    }>) {
      Object.assign(state, {
        ymdFrom: moment(new Date()).startOf('days').toDate(),
        ymdTo: moment(new Date()).startOf('days').add(14, 'days').toDate(),
        center: action.payload.centerList.filter(center => !!center.code)[0],
        maker: action.payload.makerList[0],
      });
    },
  },
});

//Page Slice Export
export const outputDataWarehousingSaveSlice = createSliceContent("outputDataWarehousingSave");
